// extracted by mini-css-extract-plugin
export default {"header":"AppsList_header__a2P6S","headerExtras":"AppsList_headerExtras__SKRca"};